/* Lana Banana: voorkeuren van de bezoeker toepassen voordat de pagina tekent
   (donkere modus en discreet kijken). Leest alleen de eigen opslag van deze site. */
(function () {
  var root = document.documentElement;
  var settings = window.theme || {};
  var stored = function (key) { try { return localStorage.getItem(key); } catch (e) { return null; } };
  var mode = settings.darkToggle ? (stored('lana-banana-theme') || 'light') : 'light';
  root.setAttribute('data-theme', mode);
  var discreet = stored('lana-banana-discreet');
  if (discreet === '1' || (discreet === null && settings.discreetDefault)) root.classList.add('is-discreet');
})();
